module.exports = __webpack_public_path__ + "static/media/girl-25.20e46af9.svg";